export default __webpack_public_path__ + "754ea5a2badeae2033e0f559d643b688.svg";